import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getConfirmationComment = id => {
  return http.get(
    `${getBaseUrl()}/confirmation_comment/${id}`
  );
};

export const getConfirmationComments = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/confirmation_comment`
    );
  }
  return http.get(
    `${getBaseUrl()}/confirmation_comment?${paginate}`
  );
};

export const updateConfirmationComment = data => {

  return http.put(
    `${getBaseUrl()}/confirmation_comment/${data.id}`,
    data
  );
};
export const submitConfirmationComment = data => {

  return http.post(
    `${getBaseUrl()}/confirmation_comment`,
    data
  );
};
